export enum ActionEnum {
  REDIRECT = 'redirect',
  NO_REDIRECT = 'no redirect',
}
